<template>
  <div class="liveing">
    <div>
      <div class="el-header">
        <div class="header_all">
          <div class="header_left">
            <p class="left_room">{{ user_title }}</p>
            <p class="left_org">{{ org_name }}</p>
          </div>
          <div class="header_right">
            <img class="right_header" :src="head_image" />
            <p class="right_name">{{ nickname }}</p>
            <img
              src="../assets/images/liveing/liveing(7).png"
              alt
              v-if="user_type === 2"
              class="right_type"
            />
            <img
              src="../assets/images/liveing/liveing(11).png"
              alt
              v-if="user_type === 3"
              class="right_type"
            />
          </div>
        </div>
      </div>
      <div class="el-main">
        <div class="center">
          <div class="center_left">
            <div class="left_liveType" v-if="!!locking">
              <ul>
                <li
                  v-for="(item, index) in liveNav"
                  :key="index"
                  @click="onliveNavData(item)"
                >
                  <img :src="item.checked ? item.imgUrl : item.imgUrlHide" />
                  <p>{{ item.text }}</p>
                </li>
              </ul>
              <div :class="liveBut == false ? 'liveType_but' : 'liveType_hide'">
                <p v-if="liveBut">直播已开始</p>
                <div @click="clickLive" class="live_status">
                  {{ liveBut == false ? "开始直播 " : " 结束直播" }}
                </div>
                <div
                  class="back"
                  v-show="liveBut == false"
                  @click="handleLiveBack"
                >
                  返回
                </div>
              </div>
            </div>
            <div class="center_lefttop" v-else>
              <div class="center_leftback" @click="handleBack">返回</div>
              <div class="center_leftuser_set">
                <!-- <div @click="questlianmai">
                  <img src="../assets/images/liveing/lianmai.png" alt class="center_leftcall" />
                  <p>请求连麦</p>
                </div>-->
                <div @click="getCamera">
                  <img
                    src="../assets/images/liveing/shezhi.png"
                    alt
                    class="center_leftsetting"
                  />
                  <p>设备调试</p>
                </div>
              </div>
            </div>
            <div class="left_liveing">
              <div
                v-show="noanchorplaybtn"
                class="liveingplay"
                @click="noanchorplay"
              >
                <img src="../assets/images/liveing/playone.png" alt="" />
              </div>
              <div id="video_wrap" v-show="!!threeLive"></div>
              <div class="video_wrap" v-show="!threeLive">
                <video id="videoElement"></video>
              </div>
            </div>
            <div class="LmLayer" v-show="overLiveing">
              <div class="Layer_item">确定要结束直播</div>
              <div class="layer_but">
                <div class="but_No" @click="bindoverLiveing">取消</div>
                <div class="but_Yes" @click="overliveingclick()">确定</div>
              </div>
            </div>
            <div class="LmLayer" v-show="LMLayserShow">
              <div class="Layer_item">主播请求连麦</div>
              <div class="layer_but">
                <div class="but_No" @click="bindLianmaiNoBut(LMstudentId)">
                  取消
                </div>
                <div class="but_Yes" @click="onLianmaiYesBut(LMstudentId)">
                  确定
                </div>
              </div>
            </div>
            <div class="LmLayer" v-show="LMOrgShow">
              <div class="Layer_item">确定与{{ LMUserName }}连麦</div>
              <div class="layer_but">
                <div class="but_No" @click="bindLMColseShowData">取消</div>
                <div class="but_Yes" @click="onOrgLianmaiYesBut()">确定</div>
              </div>
            </div>
            <div class="LmLayer" v-show="LMColseShow">
              <div class="Layer_item">是否断开与 {{ LMUserName }} 连麦</div>
              <div class="layer_but">
                <div class="but_No" @click="bindLMColseShowData">取消</div>
                <div class="but_Yes" @click="bindColseLiveData(LMstudentId)">
                  断开
                </div>
              </div>
            </div>
            <div class="LmLayer" v-show="LMColseLoading">
              <div class="Layer_item">等待连麦中...</div>
              <div class="layer_but">
                <div class="but_No" @click="bindLMColseLoading">取消</div>
              </div>
            </div>
            <div class="LmLayer" v-show="ColseLoading">
              <div class="Layer_item">用户已取消连麦</div>
              <div class="layer_but">
                <div class="but_No" @click="bindColseLoading">关闭</div>
              </div>
            </div>
          </div>
          <div class="center_right" v-show="!!isJoined_">
            <ul class="right_navData">
              <li
                @click="onMessageData('messageType')"
                :class="[contentData === 'messageType' && 'right_show']"
              >
                消息
              </li>
              <li
                @click="onMessageData('audienceType')"
                :class="[contentData === 'audienceType' && 'right_show']"
              >
                观众
              </li>
            </ul>
            <div class="right_content">
              <!-- 信息列表 -->
              <div
                class="content_message"
                v-show="contentData == 'messageType'"
              >
                <ul class="message" id="msgText">
                  <li
                    :class="msg.send == userId ? 'myLive' : ''"
                    v-for="(msg, index) in messagess"
                    :key="index"
                  >
                    <div class="items_header">
                      <span>{{ msg.fromAccountNick }}</span>
                      <img
                        class="user_type"
                        v-if="msg.user_type == 0 && msg.send != anchorId"
                        src="../assets/images/liveing/liveing(10).png"
                      />
                      <img
                        class="user_type"
                        v-else-if="msg.user_type == 1 && msg.send != anchorId"
                        src="../assets/images/liveing/liveing(10).png"
                      />
                      <img
                        class="user_type"
                        v-else-if="msg.user_type == 2 && msg.send != anchorId"
                        src="../assets/images/liveing/liveing(7).png"
                      />
                      <img
                        class="user_type"
                        v-else-if="msg.user_type == 3 && msg.send != anchorId"
                        src="../assets/images/liveing/liveing(11).png"
                      />
                      <img
                        src="../assets/images/liveing/liveing(8).png"
                        v-if="msg.send == anchorId"
                      />
                    </div>
                    <label
                      :class="msg.send == userId ? 'mylive_text' : 'items_text'"
                      >{{ msg.content }}</label
                    >
                  </li>
                </ul>
                <div class="output">
                  <!-- <input placeholder="快参与互动吧" v-model="mesg" @keyup.enter="sendCustomGroupMsg" /> -->
                  <textarea
                    placeholder="快参与互动吧"
                    v-model="mesg"
                    @keyup.enter="sendCustomGroupMsg"
                  ></textarea>

                  <div class="send">
                    <button
                      @click="sendCustomGroupMsg"
                      :class="{ sendbtn: !sendbtn }"
                    >
                      发送
                      <span v-if="!sendbtn">({{ sendnum }})</span>
                    </button>
                  </div>
                </div>
              </div>
              <!-- 观众列表 -->
              <div
                class="content_audience"
                v-show="contentData == 'audienceType'"
                @click="onUserShowHide()"
              >
                <ul>
                  <li v-for="(item, index) in userList" :key="index">
                    <div class="userinfo">
                      <img class="user_head" :src="item.avatar_url" />
                      <img
                        v-if="item.role.role_id == 2"
                        class="user_type"
                        src="../assets/images/liveing/liveing(7).png"
                      />
                      <img
                        v-if="item.role.role_id == 1"
                        class="user_type"
                        src="../assets/images/liveing/liveing(10).png"
                      />
                      <img
                        v-if="item.role.role_id == 3"
                        class="user_type"
                        src="../assets/images/liveing/liveing(11).png"
                      />
                      <p class="user_name">{{ item.nickname }}</p>
                      <p v-if="item.is_admin == 1" class="addAdmin">管理员</p>
                      <p v-if="item.is_forbid == 1" class="speech">已禁言</p>
                      <!-- <p v-if="LMID == item.user_id" v-for="LMID in  listLMID" class="liveing_show">连麦中</p> -->
                      <div
                        @click.stop="onUserinfoData(item.user_id)"
                        v-if="!!locking"
                      >
                        <img
                          class="user_mor"
                          src="../assets/images/liveing/mor.png"
                        />
                      </div>
                    </div>
                    <div
                      class="userlayer"
                      v-show="userlayer"
                      v-if="checkedUseuId == item.user_id"
                    >
                      <!-- <div>连麦</div> -->
                      <!-- <div @click="onSpeechBut(item.user_id,index)">{{item.is_forbid == 0?'禁言':'取消禁言'}}</div> -->
                      <div @click="onGetOutBut(item.user_id)">踢出</div>
                      <div v-if="item.is_admin == 0" @click="onAdminBut(item)">
                        设为管理员
                      </div>
                      <div
                        v-if="item.is_admin == 1"
                        @click="onAdminNoBut(item)"
                      >
                        撤销管理员
                      </div>
                      <div @click="onLianmaiBut(item)">连麦</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <!-- 连麦设置弹框 -->
      <div class="lianmaibigbox">
        <el-dialog
          title="连麦设置"
          :visible.sync="centerDialogVisibledia"
          width="50%"
          center
        >
          <div class="lianmaiglo">
            <div class="lianmaileft">
              <div>管理员连麦</div>
              <div>打开以后，只有管理员可以发起连麦</div>
            </div>
            <div class="lianmairight">
              <el-switch v-model="dialogbtn"></el-switch>
            </div>
          </div>
          <div class="lianmaiglo">
            <div class="lianmaileft">
              <div>切换连麦显示</div>
            </div>
            <div class="lianmairight">
              <div
                :class="[
                  lianmaiseenp == '1'
                    ? 'lianmaichenlid liancurrent'
                    : 'lianmaichenlid',
                ]"
                @click="clicklianmaiseenp('1')"
              >
                左右显示
              </div>
              <div
                :class="[
                  lianmaiseenp == '2'
                    ? 'lianmaichenlid liancurrent'
                    : 'lianmaichenlid',
                ]"
                @click="clicklianmaiseenp('2')"
              >
                上下显示
              </div>
            </div>
          </div>
          <div class="lianmaiglo">
            <div class="lianmaileft">
              <div>断开所有连麦</div>
            </div>
            <div class="lianmairight">
              <el-button type="info">离开</el-button>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisibledia = false">取 消</el-button>
            <el-button type="primary" @click="centerDialogVisibledia = false"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
      <!-- 连麦弹框 -->
      <div
        class="liveingtwo"
        v-on:mousemove="dataDetails($event)"
        v-show="livetwobtn"
        :style="{ left: floatLeft, top: floatTop }"
      >
        <div class="liveingtwoclose" @click.stop="livetwobtnclick">X</div>
        <div class="title_item">正在与 {{ LMUserName }} 连麦</div>
        <div
          id="video_wraptwo"
          v-on:mousedown="setmovebtn"
          v-on:mouseup="setmovebtn"
        ></div>
      </div>
      <!-- 设备检测弹框 -->
    </div>
    <deteCtion
      v-if="equipmentboxbtn"
      :cameraEquiDatas="cameraEquiData"
      :microphoneQquidatas="microphoneQquidata"
      :speakersDatas="speakersData"
      @close_btn="equipmentboxbtnqus"
      @close="equipmentboxbtn = false"
      :microphoneIds="microphoneId"
      :cameraIds="cameraId"
    />
    <!-- <deteCtionCopy  v-if="equipmentboxbtn"/> -->
  </div>
</template>
<script>
import Footer from "@/components/Footer";
// @ is an alias to /src
import LibGenerateTestUserSig from "@/assets/global/lib-generate-test-usersig.min.js";
import FLV from "@/assets/js/flv.min.js";
import TRTC from "@/assets/js/trtc.js";
import TIM from "tim-js-sdk";
import COS from "cos-js-sdk-v5";
import Live from "@/assets/js/live";
import deteCtion from "../components/Detection";
import deteCtionCopy from "../components/Detectioncopy";
var linkchat = "chat"; //普通聊天
var linkmicApply = "link_mic:apply"; //连麦申请
var linkMicAccept = "link_mic:accept"; //连麦接受
var link_micReject = "link_mic:reject"; //连麦拒绝
var link_micStop = "link_mic:stop"; //连麦结束
var viewerForbid = "viewer:forbid"; //禁言
var viewerJoin = "viewer:join"; //观众进来
var viewerExit = "viewer:exit"; //观众离开
var liveEnd = "live:end"; //直播结束
var viewerRemove = "viewer:remove"; //踢出
var anchorClose_camera = "anchor:close_camera"; //主播关闭摄像头
var anchorSharing_screen = "anchor:sharing_screen"; //主播共享屏幕
var adminSet = "admin:set"; //管理员设置
var adminCancel = "admin:cancel"; //管理员取消设置
export default {
  name: "live",
  data() {
    return {
      microphoneId: "",
      cameraId: "",
      sendnum: 5,
      sendbtn: true,
      equipmentboxbtn: false,
      cameraEqui: "",
      microphoneQqui: "",
      cameraEquiData: [],
      microphoneQquidata: [],
      speakersData: [],
      lianmaiseenp: "1",
      dialogbtn: false,
      centerDialogVisibledia: false,
      user_title: "",
      org_name: "",
      nickname: "",
      head_image: "",
      liveBut: false,
      LMColseLoading: false,
      ColseLoading: false,
      userlayer: false,
      live_id: "", //直播id
      group_id: "", //组id
      liveNav: [
        {
          id: 1,
          imgUrl: require("../assets/images/liveing/liveing(6).png"),
          text: "关闭摄像头",
          checked: false,
          imgUrlHide: require("../assets/images/liveing/liveing(15).png"),
        },
        {
          id: 2,
          imgUrl: require("../assets/images/liveing/liveing(3).png"),
          text: "关闭麦克风",
          checked: false,
          imgUrlHide: require("../assets/images/liveing/liveing(13).png"),
        },
        {
          id: 3,
          imgUrl: require("../assets/images/liveing/liveing(1).png"),
          text: "共享屏幕",
          checked: false,
          imgUrlHide: require("../assets/images/liveing/liveing(1).png"),
        },
        // {
        //   id: 4,
        //   imgUrl: require('../assets/images/liveing/lianmai.png'),
        //   text: '连麦设置',
        //   checked: false,
        //   imgUrlHide: require('../assets/images/liveing/lianmai.png'),
        // },
        {
          id: 5,
          imgUrl: require("../assets/images/liveing/shezhi.png"),
          text: "设备调试",
          checked: false,
          imgUrlHide: require("../assets/images/liveing/shezhi.png"),
        },
      ],
      messagess: [],
      mesg: "",
      userList: [],
      checkedUseuId: "",
      contentData: "messageType",
      userId: "", //用户id --可更改
      roomId: "", //房间号--加入相同房间才能聊
      client_: "", //客户端服务
      tim: [],
      localStream: "", //本地流
      userSig: "", //用户token
      usersigIM: "", //IM使用usersig
      sdkappidImres: "", // IM使用appid
      studentVideo: false, //学生连麦后的弹窗
      isJoined_: false,
      LMstudentId: "",
      LMOrgShow: false,
      LMUserName: "", //连麦中的学生name
      LMLayserShow: false, //连麦弹窗
      LMColseShow: false, //连麦断流弹窗
      isPublished_: false,
      isClick: false,
      localStream_: null,
      locking: true, //是否是主播
      user_type: "2",
      timerss: [], //用户列表心跳
      floatLeft: "",
      floatTop: "",
      movebtn: false,
      livetwobtn: false, //第二个盒子的开关
      liveinteraction: true, //互动开关
      liveinteractionbtn: false,
      transcode: 0,
      anchorId: "",
      overLiveing: false,
      threeLive: true,
      noanchorplaybtn: false,
      is_anchor: false, //进来判断是否是主播
      bypass_switch: false, //是否开启旁路
      stream_id: "",
      myUserInfo: "",
    };
  },
  components: { deteCtion, deteCtionCopy, Footer },
  destroyed() {
    var _t = this;
    window.removeEventListener("unload", (e) => _t.unloadFn());
    window.removeEventListener("beforeunload", (e) => _t.beforeunloadFn(e));
    if (_t.liveBut) {
      _t.tim.off(TIM.EVENT.MESSAGE_RECEIVED, _t.onMessageReceived);
      _t.tim.off(TIM.EVENT.SDK_READY, _t.onSdkReady);
    }
    clearTimeout(this.timer);
    clearTimeout(this.timerss);
    sessionStorage.clear();
    _t.messagess = [];
  },
  created() {
    var _t = this;
    window.addEventListener("unload", (e) => this.unloadFn());
    window.addEventListener("beforeunload", (e) => this.beforeunloadFn(e));
  },
  mounted() {
    var _t = this;
    _t.myUserInfo = localStorage.getItem("setUserInfo");
    _t.userId = localStorage.getItem("userid")
      ? localStorage.getItem("userid")
      : JSON.parse(_t.myUserInfo).user_id + "";
    if (_t.$route.params.password) {
      _t.password = _t.$route.params.password;
    }
    _t.live_id = _t.$route.params.id + "";
    _t.getLivingData();
  },
  methods: {
    unloadFn() {
      var _t = this;
      this._gap_time = new Date().getTime() - this._beforeUnload_time;
      if (this._gap_time <= 5) {
        console.log("关闭");
        sessionStorage.clear();
      } else {
        console.log("刷新");
        sessionStorage.setItem("reload", 1);
      }
    },
    beforeunloadFn(e) {
      this._beforeUnload_time = new Date().getTime();
      e = e || window.event;
      if (e) {
        e.returnValue = "您是否确认离开此页面-您输入的数据可能不会被保存";
      }
      return "您是否确认离开此页面-您输入的数据可能不会被保存";
    },
    // 返回
    handleLiveBack() {
      console.log(123);
      // this.quit();
      this.$router.replace("/profile");
    },
    //观众点击开始播放
    noanchorplay() {
      var _t = this;
      _t.noanchorplaybtn = false;
      _t.geTrtc_user_sig();
      _t.messagess = [];
      _t.timerss = setInterval(() => {
        _t.userInfoList();
      }, 30000);
    },
    // 初始化数据
    userinfo() {
      var _t = this;
      //是主播
      if (_t.is_anchor) {
        _t.head_image = localStorage.head_image;
        _t.nickname = localStorage.nickname;
        _t.org_name = localStorage.org_name;
        _t.account = localStorage.user_id;
        _t.isJoined_ = false;
        _t.isPublished_ = false;
        _t.localStream_ = null;
        _t.remoteStreams_ = [];
        _t.anchorId = localStorage.userid;
        //是否是预直播
        if (_t.is_anchor == 2) {
          _t.getLivingData();
        } else {
          _t.sdkappidImres = localStorage.sdkappidImres;
          _t.usersigIM = localStorage.usersigIM;
          _t.user_title = localStorage.title;
          _t.sdkAppId = localStorage.sdkappid;
          _t.userSig = localStorage.userToken;
          _t.group_id = localStorage.group_id;
          _t.bypass_switch = localStorage.bypass_switch || 1;
          _t.stream_id = localStorage.stream_id;
          _t.getLivingData("live");
        }
        _t.timerss = setInterval(() => {
          _t.userInfoList();
        }, 30000);
      } else {
        //不是主播
        _t.getLivingData();
      }
    },
    //获取直播间信息
    getLivingData() {
      var _t = this;
      var password = "";
      password = _t.password || localStorage.livePassword;
      this.$request
        .getLivingData({
          live_id: _t.live_id,
          password: password,
        })
        .then((res) => {
          console.log(res);
          _t.myUserInfo = localStorage.getItem("setUserInfo");
          var id = JSON.parse(_t.myUserInfo).user_id;
          _t.user_title = res.data.title;
          _t.head_image = res.data.user.avatar_url;
          _t.nickname = res.data.user.nickname;
          _t.org_name = res.data.user.org_name;
          _t.anchorId = res.data.user.user_id;
          _t.roomId = res.data.room_id;
          _t.group_id = res.data.group_id;
          _t.stream_id = res.data.stream_id;
          if (id == res.data.user.user_id) {
            _t.account = localStorage.user_id;
            _t.isJoined_ = false;
            _t.isPublished_ = false;
            _t.localStream_ = null;
            _t.remoteStreams_ = [];
            _t.geTrtc_user_sig();
            _t.timerss = setInterval(() => {
              _t.userInfoList();
            }, 30000);
          } else {
            _t.user_type = localStorage.user_type;
            _t.locking = false;
            _t.noanchorplaybtn = true;
            _t.anchorurl = res.data.stream_id;
          }
        });
    },
    // 采集摄像头
    getCamera() {
      // 先获取授权，否则无法拿到完整的设备信息
      navigator.mediaDevices.getUserMedia({
          audio: true,
          video: true
        })
        .then(() => {
          TRTC.getCameras().then((devices) => {
            let cameras = devices;
            this.cameraEquiData = cameras;
            if (cameras == null) {
              this.camerasquest();
            } else {
              this.equipmentboxbtn = true;
            }
          });
          TRTC.getMicrophones().then((devices) => {
            let microphones = devices;
            this.microphoneQquidata = microphones;
            console.log(microphones);
          });
        }).catch(()=>{
          alert("当前无可用设备，请确认已连接摄像头和麦克风");
        });
    },
    camerasquest() {
      var constraints = { audio: true, video: true };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          this.getCamera();
        })
        .catch(function (err) {
          alert("请确认已连接摄像头和麦克风并授予其访问权限");
        });
    },
    equipmentboxbtnqus(e) {
      console.log(e);
      this.equipmentboxbtn = false;
      let cameraId = e.cameraId;
      this.cameraId = e.cameraId;
      this.microphoneId = e.microphoneId;
      if (this.localStream_ == null) {
        this.localStream_ = TRTC.createStream({ audio: true, video: true });
        // 设置视频分辨率帧率和码率
      }
      console.log(
        this.localStream_,
        "~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~"
      );
      this.localStream_.setVideoProfile("1080p");
      this.localStream_.setAudioProfile("high");
      if (cameraId != "") {
        this.localStream_
          .switchDevice("video", cameraId)
          .then(() => {
            this.$message({
              message: "切换成功",
              type: "success",
            });
          })
          .catch(function (err) {
            alert("切换失败请查看摄像头是否被占用或有效");
          });
        if (e.microphoneId != "") {
          this.localStream_.switchDevice("audio", e.microphoneId).then(() => {
            this.$message({
              message: "切换音频成功",
              type: "success",
            });
          });
        }
      }
    },
    clicklianmaiseenp(e) {
      this.lianmaiseenp = e;
    },
    dataDetails(e) {
      if (this.movebtn) {
        this.floatLeft = e.clientX - 175 + "px";
        this.floatTop = e.clientY - 125 + "px";
      }
    },
    livetwobtnclick() {
      this.LMColseShow = true;
    },
    bindoverLiveing() {
      this.overLiveing = false;
    },
    //点击确定离开直播间
    overliveingclick() {
      this.onleveroom();
      this.quit();
      this.liveNav[0].checked = false;
      this.liveNav[1].checked = false;
      this.$router.replace("/profile");
    },
    setmovebtn() {
      this.movebtn = !this.movebtn;
    },
    //主播点击开始
    clickLive() {
      var _t = this;
      if (_t.liveBut) {
        this.overLiveing = true;
      } else {
        _t.messagess = [];
        if (!_t.isJoined_) {
          this.createClient();
          this.liveNav[0].checked = true;
          this.liveNav[1].checked = true;
          this.isClick = true;
        } else {
          _t.publish();
        }
      }
    },
    handleBack() {
      var _t = this;
      _t.$router.replace("/profile");
      clearTimeout(this.timerss);
      clearTimeout(this.timer);
    },
    //获取titc签名
    geTrtc_user_sig() {
      var _t = this;
      this.$request.geTrtc_user_sig().then((res) => {
        localStorage.userToken = res.data.user_sig; //titc直播签名
        localStorage.sdkappid = res.data.sdk_app_id; //Titc appid
        _t.sdkAppId = res.data.sdk_app_id;
        _t.userSig = res.data.user_sig;
        _t.bypass_switch = res.data.bypass_switch;
        console.log("旁路流开关" + res.data.bypass_switch);
        if (_t.is_anchor == false) {
          if (res.data.bypass_switch == 1) {
            _t.anchorurl =
              res.data.bypass_play_domain + "/" + _t.stream_id + ".flv";
            if (FLV.isSupported()) {
              var videoElement = document.getElementById("videoElement");
              var flvPlayer = FLV.createPlayer({
                type: "flv",
                url: _t.anchorurl,
              });
              flvPlayer.attachMediaElement(videoElement);
              flvPlayer.load();
              flvPlayer.play();
            }
          }
          _t.imDatausersig();
        }
      });
    },
    //获取IMusersig
    imDatausersig() {
      var _t = this;
      this.$request.getImUsersig().then((res) => {
        localStorage.usersigIM = res.data.user_sig; //IM签名
        localStorage.sdkappidImres = res.data.sdk_app_id; //Im appid
        _t.usersigIM = res.data.user_sig;
        _t.sdkappidImres = res.data.sdk_app_id;
        if (_t.is_anchor == false) {
          _t.initIm();
        }
      });
    },
    //用户列表
    userInfoList() {
      var _t = this;
      _t.$request
        .showMessageInBox({
          live_id: _t.live_id,
        })
        .then((res) => {
          console.log(res);
          _t.userList = res.data.list;
        });
    },
    /*** 退出课堂*/
    quit() {
      var _t = this;
      const that = this;
      that.$request
        .quit({
          live_id: Number(_t.live_id),
        })
        .then((res) => {
          this.overLiveing = false;
          if (res.error_code == 0) {
            that.logout();
            localStorage.removeItem("live_id");
            clearTimeout(that.timer);
            // that.$router.go(-1);
            // window.location.href = 'information.html'
          } else {
            that.logout();
            // that.$router.go(-1);
            // self.showErrorTip(res.data.error);
            // window.location.href = 'information.html'
          }
        });
    },
    //踢出房间
    onGetOutBut(userid) {
      let that = this;
      this.onUserShowHide();
      that.$request
        .onGetOutBut({
          live_id: Number(that.live_id),
          to_user_id: Number(userid),
        })
        .then((res) => {
          console.log(res);
        });
    },
    // 设置管理员
    onAdminBut(item) {
      let that = this;
      this.onUserShowHide();
      that.$request
        .onAdminBut({
          to_user_id: Number(item.user_id),
          room_id: Number(that.roomId),
          action: 1,
        })
        .then((res) => {
          console.log(res.data);
        });
    },
    //取消管理员
    onAdminNoBut(item) {
      let that = this;
      this.onUserShowHide();
      that.$request
        .onAdminBut({
          to_user_id: Number(item.user_id),
          room_id: Number(that.roomId),
          action: 0,
        })
        .then((res) => {
          if (res.data.status == 1) {
            item.has_admin = 0;
          }
        });
    },
    //im群聊
    send_group_msg(msg_body) {
      let that = this;
      that.$request
        .send_group_msg({
          group_id: that.group_id,
          msg_body: msg_body,
        })
        .then((res) => {
          console.log(res);
          if (res.error_code == 0) {
            that.mesg = "";
          } else {
            that.$message(res.message);
          }
        });
    },
    //im私聊
    send_msg(to_user_id, msg_body) {
      let that = this;
      that.$request
        .send_msg({
          to_user_id: Number(to_user_id),
          msg_body: msg_body,
        })
        .then((res) => {
          console.log(res.error_code);
          if (res.error_code == 0) {
            that.mesg = "";
          } else {
            that.$message(res.message);
          }
        });
    },
    // 登出
    logout() {
      let that = this;
      //退出群组
      if (that.locking) {
        //群主解散，不是群主退出该群
        console.log(that.tim, that.group_id);
        let quitGroup = that.tim.dismissGroup(that.group_id);
        console.log(quitGroup, "@@@");
        quitGroup
          .then(function (imResponse) {
            // 解散成功
            console.log(imResponse.data.groupID, "解散成功"); // 被解散的群组 ID
          })
          .catch(function (imError) {
            console.warn("dismissGroup error:", imError); // 解散群组失败的相关信息
          });
      } else {
        let quitGroup = that.tim.quitGroup(that.group_id);
        quitGroup
          .then(function (imResponse) {
            console.log("退出成功的群");
            // console.log(imResponse.data.groupID); // 退出成功的群 ID
          })
          .catch(function (imError) {
            console.warn("quitGroup error:", imError, "退出群组失败的相关信息"); // 退出群组失败的相关信息
          });
      }
      let promise = that.tim.logout();
      that.leave();
      promise
        .then(function (imResponse) {
          console.log("登出成功"); // 登出成功
        })
        .catch(function (imError) {
          console.warn("logout error:", imError);
        });
    },
    /*** 退出房间*/
    async leave() {
      var _t = this;
      if (!this.isJoined_) {
        console.warn(
          "leave() - leave without join()d observed" + "请先加入房间"
        );
        return;
      }

      if (this.isPublished_) {
        // ensure the local stream has been unpublished before leaving.
        await this.unpublish(true);
      }

      try {
        // leave the room
        await this.client_.leave();
        console.log("退房成功");
        // Toast.notify('退房成功！');
        this.isJoined_ = false;
      } catch (error) {
        console.error("failed to leave the room because " + error);
        location.reload();
      } finally {
        if (this.localStream_ != null) {
          // 停止本地流，关闭本地流内部的音视频播放器
          this.localStream_.stop();
          // 关闭本地流，释放摄像头和麦克风访问权限
          console.log(this.localStream_);
          this.localStream_.close();
          // this.localStream_ = null;
        }
        if (!this.locking) {
          // 退出直播间
          this.$router.replace("/profile");
          //退出停止连麦
          if (_t.liveinteractionbtn) {
            _t.bindYseLiveData(); //通知主播
            _t.unpublish(true);
            // 停止本地流，关闭本地流内部的音视频播放器
            _t.localStream_.stop();
            // 关闭本地流，释放摄像头和麦克风访问权限
            _t.localStream_.close();
          }
        }
      }
    },
    async unpublish(isLeaving) {
      console.log(isLeaving);
      if (!this.isJoined_) {
        console.warn("unpublish() - please join() firstly");
        return;
      }
      if (!this.isPublished_) {
        console.warn("RtcClient.unpublish() called but not published yet");
        return;
      }

      try {
        // 停止发布本地流
        await this.client_.unpublish(this.localStream_);
        this.isPublished_ = false;
        this.liveBut = false;
        console.log("停止发布本地流成功！");
      } catch (error) {
        console.error("failed to unpublish local stream because " + error);
        if (!isLeaving) {
          console.warn("leaving the room because unpublish failure observed");
        }
      }
    },
    // 初始化IM
    initIm() {
      let options = {
        SDKAppID: this.sdkappidImres, // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
      };
      // 创建 SDK 实例，TIM.create() 方法对于同一个 SDKAppID 只会返回同一份实例
      this.tim = TIM.create(options); // SDK 实例通常用 tim 表示
      this.addTICMessageListener();
      // 设置 SDK 日志输出级别，详细分级请参见 setLogLevel 接口的说明
      this.tim.setLogLevel(0); // 普通级别，日志量较多，接入时建议使用
      // 注册 COS SDK 插件
      this.tim.registerPlugin({ "cos-js-sdk": COS });
      this.login();
    },
    // 登录
    login() {
      let that = this;
      console.log("进来登录function但是未登录");
      console.log(this.userId, this.usersigIM);
      let promise = this.tim.login({
        userID: this.userId,
        userSig: this.usersigIM,
      });
      promise
        .then(function (imResponse) {
          console.log("登录成功", that.group_id);
          that.tim
            .joinGroup({
              groupID: that.group_id,
              type: TIM.TYPES.GRP_AVCHATROOM,
            })
            .then((res) => {})
            .catch(function (imError) {
              console.warn("joinGroup error:", imError); // 申请加群失败的相关信息
            });
          // 如果是观众就需要拉流
          if (!that.locking) {
            that.createClient();
          }
          if (imResponse.data.repeatLogin === true) {
            // 标识账号已登录，本次登录操作为重复登录。v2.5.1 起支持
            console.log("已经登录了");
          }
        })
        .catch(function (imError) {
          console.warn("login error:", imError); // 登录失败的相关信息
        });
    },
    //创建直播链接
    async createClient() {
      //获取签名
      var _t = this;
      const sdkAppId = this.sdkAppId;
      const userSig = this.userSig;
      const userId = this.userId;
      console.log(sdkAppId, userId, userSig);
      this.client_ = TRTC.createClient({
        mode: "live",
        sdkAppId,
        userId,
        userSig,
        streamId: _t.stream_id,
      });
      console.log("开始创建直播");
      if (this.locking) {
        //直播推流
        this.initTRTCEvent();
        //初始化后才能加入房间
        console.log("初始化后才能加入房间");
        await this.joinRoom(this.client_, Number(this.live_id));
      } else {
        //观众拉流
        await this.initTRTCEventtwo();
        try {
          // join the room
          await this.client_.join({
            roomId: Number(this.live_id),
            role: "audience",
          });
          console.log(this.roomId + "+进房成功");
          this.isJoined_ = true;
        } catch (error) {
          console.error("failed to join room because: " + error);
          console.log("进房失败原因：" + error);
          return;
        }
      }
    },
    //加入房间
    joinRoom(client, roomId) {
      var _t = this;
      console.log(roomId);
      client
        .join({ roomId, role: "anchor" })
        .catch((error) => {
          console.error("进房失败 " + error);
        })
        .then(() => {
          _t.isJoined_ = true;
          _t.enableCamera = true;
          _t.enableMic = true;
          console.log("进房成功");
          _t.publish();
        });
    },
    //开启旁路流
    openorder() {
      var _t = this;
      _t.$request
        .start_mix_transcode_mix({
          live_id: Number(_t.live_id),
        })
        .then((res) => {
          console.log(res + "旁路流~~~~~~~");
          if (res.error_code == 0) {
            _t.$message.closeAll();
            _t.$message({
              message: "直播成功~",
              type: "success",
            });
            _t.publishLocalStream(this.localStream_);
            if (_t.locking) {
              this.initIm();
            }
          } else {
            if (_t.transcode < 3) {
              _t.transcode += 1;
              _t.openorder();
            } else {
              _t.$message.closeAll();
              _t.$message({
                message: "直播开启失败，请重新尝试",
                type: "warning",
              });
            }
          }
        });
    },
    // 开始推流
    async publish() {
      var _t = this;
      if (this.isPublished_) {
        console.warn("duplicate RtcClient.publish() observed");
        // Toast.error('当前正在推流！');
        return;
      }
      try {
        // 采集摄像头和麦克风视频流
        await this.createLocalStream({ audio: true, video: true });
        console.log("createLocalStream with audio/video success");
      } catch (error) {
        console.error("createLocalStream with audio/video failed: " + error);
        alert("请确认已连接摄像头和麦克风并授予其访问权限！");
        try {
          // fallback to capture camera only
          await this.createLocalStream({ audio: false, video: true });
          // Toast.info('采集摄像头成功！');
        } catch (error) {
          console.error("createLocalStream with video failed: " + error);
          return;
        }
      }
      this.localStream_.on("player-state-changed", (event) => {
        console.log(`local stream ${event.type} player is ${event.state}`);
        if (event.type === "video" && event.state === "PLAYING") {
          // dismiss the remote user UI placeholder
        } else if (event.type === "video" && event.state === "STOPPPED") {
          // show the remote user UI placeholder
        }
      });
      this.$message({
        message: "直播开启中",
        type: "success",
        duration: 0,
      });
      this.transcode = 0;
      await this.imDatausersig();
      if (this.bypass_switch == 1) {
        //开启旁路
        this.openorder();
      } else if (this.bypass_switch == 0) {
        _t.$message.closeAll();
        _t.$message({
          message: "直播成功~",
          type: "success",
        });
        _t.publishLocalStream(this.localStream_);
      }
    },

    publishLocalStream(localStream_) {
      console.log(localStream_);
      window.localStream = localStream_;
      localStream
        .initialize()
        .then(() => {
          if (this.locking) {
            this.liveBut = true;
            localStream_.play("video_wrap");
          } else {
            this.livetwobtn = true;
            localStream_.play("video_wraptwo");
          }
          // 发布本地流
          this.client_.publish(localStream_);
          this.isPublished_ = true;
          console.log(
            "开播成功~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~"
          );
        })
        .catch((error) => {
          // 本地流初始化失败
          this.isPublished_ = false;
          if (this.isShare) {
            // 用户取消分享
            this.isShare = false;
            this.publish();
          }
          if (!this.locking) {
            alert(
              "暂时无法访问摄像头/麦克风，请确保当前没有其他应用请求访问摄像头/麦克风"
            );
            // 告诉主播没有摄像头
            // this.messageDataType(liveEnd);
          }
          console.log(
            "暂时无法访问摄像头/麦克风，请确保当前没有其他应用请求访问摄像头/麦克风" +
              error
          );
          switch (error.name) {
            case "NotReadableError":
              // 提示用户：暂时无法访问摄像头/麦克风，请确保当前没有其他应用请求访问摄像头/麦克风，并重试。
              break;
            default:
              break;
          }
        });
    },
    //采集摄像头
    async createLocalStream(options) {
      var _t = this;
      console.log(_t.userId);
      if (this.localStream_ == null) {
        this.localStream_ = TRTC.createStream({
          audio: true, // 采集麦克风
          video: true, // 采集摄像头
          userId: this.userId,
        });
      }
      //  navigator.mediaDevices.getSupportedConstraints().autoGainControl= false;
      //  console.log(navigator.mediaDevices.getSupportedConstraints(),'~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
      // 设置视频分辨率帧率和码率
      this.localStream_.setVideoProfile("1080p");
      this.localStream_.setAudioProfile("high");
      await this.localStream_.initialize();
    },
    // TRTC事件
    initTRTCEvent() {
      // 处理 client 错误事件，错误均为不可恢复错误，建议提示用户后刷新页面
      console.log(this.client_);
      this.client_.on("error", (err) => {
        console.error(err);
        alert(err);
      });
      // 处理用户被踢事件，通常是因为房间内有同名用户引起，这种问题一般是应用层逻辑错误引起的
      // 应用层请尽量使用不同用户ID进房
      this.client_.on("client-banned", (err) => {
        console.error("client has been banned for " + err);
      });
      // 远端用户进房通知 - 仅限主动推流用户
      this.client_.on("peer-join", (evt) => {
        const userId = evt.userId;
        console.log(evt);
        console.log("peer-join");
        this.LMstudentId = userId;
        // this.studentVideo = true
      });
      // 远端用户退房通知 - 仅限主动推流用户
      this.client_.on("peer-leave", (evt) => {
        // const userId = evt.userId;
        this.listLMID = [];
        console.log(evt);
        // this.studentVideo = false
      });
      this.client_.on("stream-updated", (event) => {
        const remoteStream = event.stream;
        console.log(remoteStream + "改变订阅流~~~~~~~~~~~~~~~~~~~~~~~~~~~");
      });
      // 处理远端流增加事件
      this.client_.on("stream-added", (evt) => {
        const remoteStream = evt.stream;
        const id = remoteStream.getId();
        const userId = remoteStream.getUserId();
        console.log(
          `remote stream added: [${userId}] ID: ${id} type: ${remoteStream.getType()}`
        );
        console.log(`远端流监听`);
        // Toast.info('远端流增加 - ' + userId);
        console.log("subscribe to this remote stream");
        // 远端流默认已订阅所有音视频，此处可指定只订阅音频或者音视频，不能仅订阅视频。
        // 如果不想观看该路远端流，可调用 this.client_.unsubscribe(remoteStream) 取消订阅
        this.client_.subscribe(remoteStream);
      });

      // 远端流订阅成功事件
      this.client_.on("stream-subscribed", (evt) => {
        console.log(`播放成功要指定盒子`);
        const remoteStream = evt.stream;
        console.log(remoteStream.userId_);
        this.LMstudentId = remoteStream.userId_;
        // this.listLMID.push(this.LMstudentId)
        const id = remoteStream.getId();
        this.remoteStreams_.push(remoteStream);
        // addView(id);
        // 在指定的 div 容器上播放音视频
        this.livetwobtn = true;
        this.LMColseLoading = false;
        remoteStream.play("video_wraptwo");
        console.log("远端流订阅成功stream-subscribed ID: " + id);
        // Toast.info('远端流订阅成功 - ' + remoteStream.getUserId());
      });

      // 处理远端流被删除事件
      this.client_.on("stream-removed", (evt) => {
        const remoteStream = evt.stream;
        const id = remoteStream.getId();
        // 关闭远端流内部的音视频播放器
        remoteStream.stop();
        this.remoteStreams_ = this.remoteStreams_.filter((stream) => {
          return stream.getId() !== id;
        });
        // removeView(id);
        console.log(
          `stream-removed ID: ${id}  type: ${remoteStream.getType()}`
        );
        // Toast.info('远端流删除 - ' + remoteStream.getUserId());
      });

      // 处理远端流更新事件，在音视频通话过程中，远端流音频或视频可能会有更新
      this.client_.on("stream-updated", (evt) => {
        const remoteStream = evt.stream;
        console.log(
          "type: " +
            remoteStream.getType() +
            " stream-updated hasAudio: " +
            remoteStream.hasAudio() +
            " hasVideo: " +
            remoteStream.hasVideo()
        );
        // Toast.info('远端流更新！');
      });

      // 远端流音频或视频mute状态通知
      this.client_.on("mute-audio", (evt) => {
        console.log(evt.userId + " mute audio");
      });
      this.client_.on("unmute-audio", (evt) => {
        console.log(evt.userId + " unmute audio");
      });
      this.client_.on("mute-video", (evt) => {
        console.log(evt.userId + " mute video");
      });
      this.client_.on("unmute-video", (evt) => {
        console.log(evt.userId + " unmute video");
      });
      // 信令通道连接状态通知
      this.client_.on("connection-state-changed", (evt) => {
        console.log(5555555555555555555555555555);
        console.log(
          `RtcClient state changed to ${evt.state} from ${evt.prevState}`
        );
      });
    },
    initTRTCEventtwo() {
      var _t = this;
      console.log("观众拉流");
      _t.client_.on("stream-added", (event) => {
        const remoteStream = event.stream;
        console.log("远端流增加:stream-subscribed ", remoteStream);
        console.log(remoteStream.getUserId());
        //订阅远端流
        _t.client_.subscribe(remoteStream, { audio: true, video: true });
      });
      _t.client_.on("stream-subscribed", (event) => {
        const remoteStream = event.stream;
        // 播放远端流
        remoteStream.on("player-state-changed", (e) => {
          if (e.state === "PAUSED") {
            // resume audio/video playback
            remoteStream.resume();
          }
        });
        console.log("远端流上，本地~~~~~~~~~~~~~~~~~~~~远端流订阅成功事件");
        // if (!!_t.liveinteraction && remoteStream.getUserId() == _t.anchorId) {
        //   var divvideo = document.querySelector("#video_wrap");
        //   while (divvideo.hasChildNodes())
        //     divvideo.removeChild(divvideo.firstChild);
        //   remoteStream.play("video_wrap");
        // } else {
        // 采用带延迟的旁路流（只有在连麦等实时环节采用同步流）
        _t.threeLive = false;
        if (FLV.isSupported()) {
          var videoElement = document.getElementById("videoElement");
          var flvPlayer = FLV.createPlayer({
            type: "flv",
            url: _t.anchorurl,
          });
          console.log(_t.anchorurl);
          flvPlayer.attachMediaElement(videoElement);
          flvPlayer.load();
          flvPlayer.play();
        }
        // }
      });
      _t.client_.on("stream-updated", (event) => {
        const remoteStream = event.stream;
        console.log(
          remoteStream.getUserId() + "流上",
          _t.userId + "本地",
          _t.anchorId + "主播",
          "远端流上，本地~~~~~~~~~~~~~~~~~~~~远端流更新事件，当远端用户添加、移除或更换音视频轨道"
        );
      });
      _t.client_.on("stream-removed", (event) => {
        const remoteStream = event.stream;
        console.log(remoteStream, "停止流");
        if (remoteStream.getUserId() != _t.anchorId) {
          _t.threeLive = true;
        }
      });
    },
    onliveNavData(item) {
      if (item.id == 4 && !this.isShare) {
        this.centerDialogVisibledia = true;
      } else if (item.id == 5 && !this.isShare) {
        // 调试设备
        this.getCamera();
      }
      if (!this.isClick) {
        return;
      }
      if ((item.id == 1 && this.isShare) || (item.id == 2 && this.isShare)) {
        // 关闭麦克风/摄像头
        return;
      } else {
        item.checked = !item.checked;
        if (item.id == 1) {
          this.toggleCamera();
        } else if (item.id == 2) {
          this.toggleMic();
        } else if (item.id == 3) {
          // 分享屏幕
          this.enableCamera = true;
          this.enableMic = true;
          this.liveNav[0].checked = true;
          this.liveNav[1].checked = true;
          this.isShare = true;
          this.pushScreen();
        } else if (item.id == 4) {
          this.centerDialogVisibledia = true;
        }
      }
    },
    // 停止推流
    stopPush(callback) {
      // this.screenStream_ = screenStream
      if (this.localStream_ && this.isPublished_) {
        // console.log(screenStream)
        this.client_.unpublish(this.localStream_).then(() => {
          this.localStream_.stop();
          // this.publishLocalStream(this.screenStream_)
          if (
            Object.prototype.toString.call(callback) === "[object Function]"
          ) {
            callback();
          }
        });
      }
    },
    /*** 推屏幕分享*/
    pushScreen() {
      let that = this;
      let a = that.localStream_;
      that.messageDataType(anchorSharing_screen);
      // 从麦克风和摄像头采集本地音视频流
      const screenStream = TRTC.createStream({ screenAudio: true, screen: true });
      console.log(screenStream);
      // this.localStream_ = screenStream
      // 设置视频分辨率等参数
      screenStream.setAudioProfile("high");
      screenStream.setScreenProfile({
        width: 1920,
        height: 1080,
        frameRate: 15,
        bitrate: 1600 /* kbps */,
      });
      console.log(that.isPublished_);
      if (that.localStream_ && that.isPublished_) {
        // 如果正在推流, 先停止发布流
        // that.stopPush(screenStream)
        console.log(
          "~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~停止推流"
        );
        that.stopPush(() => {
          that.publishLocalStream(screenStream);
        });
      } else {
        console.log(2222);
        that.publishLocalStream(screenStream);
      }
      // 监听屏幕分享停止事件
      screenStream.on("screen-sharing-stopped", (event) => {
        console.log("屏幕分享停止了");
        let b = document.getElementById("video_wrap").firstChild;
        b.remove();
        that.client_.unpublish(screenStream).then(() => {
          console.log(screenStream);
          that.isPublished_ = true;
          that.isShare = false;
          that.liveNav = that.liveNav.map((v) => {
            console.log(v);
            v.checked = true;
            return v;
          });
          that.publishLocalStream(a);
        });
      });
    },
    /*** 摄像头开关*/
    toggleCamera() {
      this.enableCamera = !this.enableCamera;
      console.log(this.enableCamera);
      if (!this.enableCamera) {
        this.messageDataType(anchorClose_camera);
      }
      console.log(this.localStream_.muteVideo());
      if (this.localStream_) {
        this.enableCamera
          ? this.localStream_.unmuteVideo()
          : this.localStream_.muteVideo();
      }
    },
    /*** 麦克风开关*/
    toggleMic() {
      let that = this;
      that.enableMic = !that.enableMic;
      if (that.localStream_) {
        console.log(that.localStream_);
        that.enableMic
          ? that.localStream_.unmuteAudio()
          : that.localStream_.muteAudio();
      }
    },
    //禁言弹窗关闭
    onUserShowHide() {
      console.log("onUserShowHide");
      this.userlayer = false;
    },
    //禁言等弹窗开关
    onUserinfoData(userid) {
      let that = this;
      that.userlayer = true;
      console.log("onUserinfoData");
      that.checkedUseuId = userid;
    },
    // 点击切换
    onMessageData(res) {
      this.contentData = res;
    },
    bindColseLoading() {
      this.ColseLoading = false;
    },
    sendCustomGroupMsg() {
      if (this.sendbtn) {
        this.sendbtn = false;
        this.sendtimerfn();
        let that = this;
        if (that.mesg.trim() == "") {
          that.$message({
            message: "输入不能为空值",
            type: "warning",
          });
          return;
        }
        that.messageDataType(linkchat);
      }
    },
    sendtimerfn() {
      var _t = this;
      if (this.sendnum > 0) {
        setTimeout(() => {
          _t.sendnum -= 1;
          _t.sendtimerfn();
        }, 1000);
      } else {
        this.sendnum = 5;
        this.sendbtn = true;
      }
    },
    // 主播取消直播
    onleveroom() {
      // this.messageDataType(liveEnd);
    },
    onMessageReceived(event) {
      var that = this;
      let dataItem = event.data[0]._elements;
      if (dataItem == undefined) {
        return;
      }
      let json = "";
      let a = "";
      for (var i = 0; i < dataItem.length; i++) {
        if (dataItem[i].type == "TIMCustomElem") {
          json = JSON.parse(dataItem[i].content.data);
          dataItem[i].content.data = json;
          a = dataItem[i].content.data;
        }
      }
      console.log("监听", dataItem);
      if (a.cmd == linkmicApply) {
        that.LMstudentId = a.sender.user_id;
        that.LMUserName = a.sender.nickname;
        console.log(that.LMstudentId, that.LMUserName);
        if (that.livetwobtn == true) {
          that.bindLianmaiNoBut(a.sender.user_id);
        } else {
          that.showMessageInBox(dataItem);
        }
      } else {
        that.showMessageInBox(dataItem);
      }
      // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
      // event.name - TIM.EVENT.MESSAGE_RECEIVED
      // event.data - 存储 Message 对象的数组 - [Message]
    },
    onSdkReady(event) {
      console.log(event, "进入ready");
    },
    addTICMessageListener() {
      console.log("开始监听");
      let that = this;
      that.tim.on(TIM.EVENT.MESSAGE_RECEIVED, that.onMessageReceived);
      that.tim.on(TIM.EVENT.SDK_READY, that.onSdkReady);
    },
    //发给个人消息
    messageUserDataType(type, user_id) {
      let that = this;
      let datas = [
        {
          MsgType: "TIMCustomElem",
          MsgContent: {
            Data:
              '{"cmd":"' +
              type +
              '","payload":{"live_id":' +
              that.live_id +
              "}}",
          },
        },
      ];
      that.send_msg(user_id, datas);
    },
    // 发个群组消息
    messageDataType(type) {
      let that = this;
      var datas = "";
      if (type == "chat") {
        datas = [
          {
            MsgType: "TIMTextElem",
            MsgContent: {
              Text: that.mesg,
            },
          },
          {
            MsgType: "TIMCustomElem",
            MsgContent: {
              Data: '{"cmd":"' + type + '"}',
            },
          },
        ];
      } else {
        datas = datas = [
          {
            MsgType: "TIMCustomElem",
            MsgContent: {
              Data: '{"cmd":"' + type + '"}',
            },
          },
        ];
      }
      that.send_group_msg(datas);
    },
    showMessageInBox(dataItem) {
      let that = this;
      let data = "";
      for (var i = 0; i < dataItem.length; i++) {
        if (dataItem[i].type == "TIMCustomElem") {
          data = dataItem[i].content.data;
        }
      }
      console.log(data.cmd);
      if (data.cmd == linkchat) {
        var d = new Date();
        var time = d;
        var typetags = "";
        if (that.locking) {
          typetags = 0;
        } else {
          typetags = localStorage.user_type;
        }
        let text = "";
        for (var i = 0; i < dataItem.length; i++) {
          if (dataItem[i].type == "TIMTextElem") {
            text = dataItem[i].content.text;
          }
        }
        let arr = that.messagess;
        arr.push({
          time: time,
          send: data.sender.user_id,
          content: text,
          fromAccountNick: data.sender.nickname,
          userHeadImg: data.sender.avatar_url,
          user_type: data.sender.role.role_id,
          has_admin: data.sender.is_admin,
        });
        that.messagess = arr;
        console.log(that.messagess);
      } else if (data.cmd == viewerForbid) {
        if (!that.locking) {
          that.$message({
            message: "你已被禁言",
            type: "success",
          });
        }
      } else if (data.cmd == viewerJoin) {
        that.userInfoList();
        that.$message({
          message: data.payload.nickname + "进入直播间",
          type: "success",
        });
      } else if (data.cmd == viewerExit) {
        that.userInfoList();
        that.$message({
          message: data.payload.nickname + "退出直播间",
          type: "warning",
        });
      } else if (data.cmd == liveEnd) {
        if (that.locking) {
          // 观众麦没有打开
          that.bindLMColseShowData();
          // that.$message({
          //   message: "观众摄像头没打开",
          //   type: "warning"
          // });
        } else {
          // 主播取消直播
          that.$message({
            message: "主播已结束直播",
            type: "warning",
          });
          that.handleBack();
        }
      } else if (data.cmd == linkmicApply) {
        if (that.LMLayserShow == true) {
          //任意一方点击了取消连麦另一方弹框关闭
          that.bindLMColseShowData();
          if (that.locking) {
            that.LMColseLoading = false;
          } else {
            that.ColseLoading = true;
          }
        } else {
          that.LMLayserShow = true;
        }
      } else if (data.cmd == linkMicAccept) {
        that.$message({
          message: "正在连麦中~",
          type: "success",
        });
        that.LMColseLoading = false;
        that.lianmaitoggle();
      } else if (data.cmd == link_micReject) {
        that.$message({
          message: data.sender.nickname + "拒绝了连麦~",
          type: "warning",
        });
        that.LMColseLoading = false;
        console.log("拒绝了连麦");
      } else if (data.cmd == link_micStop) {
        if (that.LMLayserShow == true) {
          //任意一方点击了取消连麦另一方弹框关闭
          that.bindLMColseShowData();
          if (that.locking) {
            that.LMColseLoading = false;
          } else {
            that.ColseLoading = true;
          }
        } else {
          that.livetwobtn = false;
          if (that.locking) {
            that.bindYseLiveData();
            console.log("主播连麦断开");
          } else {
            console.log("观众连麦断开");
            that.unpublish(true);
            that.client_
              .switchRole("audience")
              .catch((error) => {
                console.error("角色切换失败 " + error);
              })
              .then(() => {
                console.error("角色切换成功");
              });
            // 停止本地流，关闭本地流内部的音视频播放器
            that.localStream_.stop();
            // 关闭本地流，释放摄像头和麦克风访问权限
            that.localStream_.close();
            that.liveinteractionbtn = false;
          }
        }
      } else if (data.cmd == viewerRemove) {
        if (that.locking) {
        } else {
          that.$message({
            message: "你被主播踢出房间",
            type: "warning",
          });
          that.$router.replace("/profile");
        }
      } else if (data.cmd == anchorClose_camera) {
        // 关闭摄像头
        if (that.locking) {
        } else {
          that.$message({
            message: "主播关闭摄像头了",
            type: "warning",
          });
        }
      } else if (data.cmd == anchorSharing_screen) {
        // 设置共享屏幕
        if (that.locking) {
        } else {
          that.$message({
            message: "主播正在设置共享屏幕，请稍等",
            type: "warning",
          });
        }
      }
      that.$nextTick(() => {
        var msgbox = document.querySelector("#msgText");
        msgbox.scrollTop = msgbox.scrollHeight;
      });
    },
    //断开连麦显示隐藏弹窗
    bindColseLiveData() {
      this.LMColseShow = false;
      this.bindYseLiveData();
    },
    onSpeechBut(userid, index) {
      this.onUserShowHide();
      //禁言
      const that = this;
      console.log(that.userList[index], "判断是否禁言");
      if (that.userList[index].is_forbid == 1) {
        that.userList[index].is_forbid = 0;
        that.$request
          .onSpeechBut({
            to_user_id: userid,
            second: 0,
            live_id: Number(that.live_id),
          })
          .then((res) => {
            console.log(that.userList[index], "nojin");
          });
      } else {
        that.userList[index].is_forbid = 1;
        that.$request
          .onSpeechBut({
            to_user_id: userid,
            second: 3600,
            live_id: Number(that.live_id),
          })
          .then((res) => {
            console.log(that.userList[index], "jin");
          });
      }
    },
    //拒绝连麦发一条消息
    bindLianmaiNoBut(user_id) {
      this.LMLayserShow = false;
      this.LMOrgShow = false;
      this.messageUserDataType(link_micReject, user_id);
    },
    //接收连麦发一条消息
    onLianmaiYesBut(user_id) {
      if (this.locking) {
        this.LMLayserShow = false;
        this.messageUserDataType(linkMicAccept, user_id);
      } else {
        this.LMLayserShow = false;
        this.lianmaitoggle();
        this.bindLMColseLoading();
      }
    },
    //主播确定连麦
    onOrgLianmaiYesBut() {
      this.LMOrgShow = false;
      this.LMColseLoading = true;
      var user_id = "";
      if (this.locking) {
        user_id = this.LMstudentId;
      } else {
        user_id = this.anchorId;
      }
      this.messageUserDataType(linkmicApply, user_id);
    },
    //断开连麦发一条消息
    bindYseLiveData() {
      this.LMColseShow = false;
      this.livetwobtn = false;
      if (this.locking) {
        var LMstudentId = this.LMstudentId;
      } else {
        var LMstudentId = this.anchorId;
      }
      this.messageUserDataType(link_micStop, LMstudentId);
    },
    //取消退出学生的连麦
    bindLMColseShowData() {
      this.LMColseShow = false;
      this.LMOrgShow = false;
      this.LMColseLoading = false;
      this.LMLayserShow = false;
    },
    // 取消等待连麦
    bindLMColseLoading() {
      this.LMColseLoading = false;
      if (this.locking) {
        var LMstudentId = this.LMstudentId;
      } else {
        var LMstudentId = this.anchorId;
      }
      this.messageUserDataType(link_micStop, LMstudentId);
    },
    //观众连麦
    questlianmai() {
      var _t = this;
      this.LMOrgShow = true;
      _t.LMUserName = _t.nickname;
    },
    // 连麦切换
    lianmaitoggle() {
      var _t = this;
      _t.client_
        .switchRole("anchor")
        .catch((error) => {
          console.error("角色切换失败 " + error);
        })
        .then(() => {
          _t.liveinteractionbtn = true;
          _t.initlianmai();
        });
    },
    // 初始化连麦本地流
    async initlianmai() {
      var _t = this;
      try {
        // 采集摄像头和麦克风视频流
        await this.createLocalStream({ audio: true, video: true });
        console.log("createLocalStream with audio/video success");
      } catch (error) {
        console.error("createLocalStream with audio/video failed: " + error);
        alert("请确认已连接摄像头和麦克风并授予其访问权限！");
        _t.messageUserDataType(link_micReject, _t.LMstudentId);
        try {
          // fallback to capture camera only
          await this.createLocalStream({ audio: false, video: true });
          // Toast.info('采集摄像头成功！');
        } catch (error) {
          console.error("createLocalStream with video failed: " + error);
          return;
        }
      }
      await this.publishLocalStream(this.localStream_);
    },
    //主播申请连麦弹窗
    onLianmaiBut(item) {
      this.onUserShowHide();
      console.log(item);
      this.LMstudentId = item.user_id;
      this.LMUserName = item.nickname;
      console.log(this.LMUserName);
      if (this.livetwobtn == true) {
        this.LMOrgShow = false;
        this.$message({
          message: "一次只能连麦一个",
          type: "warning",
        });
        return;
      } else {
        this.LMOrgShow = true;
      }
    },
  },
  funConsole(a) {
    if (this.getQueryVariable("debug")) {
      console.log(a);
    }
  },
  getQueryVariable(item) {
    var sValue = window.location.href.match(
      new RegExp("[?&]" + item + "=([^&]*)(&?)", "i")
    );
    return sValue ? sValue[1] : sValue;
  },
};
</script>
<style scoped src="../assets/css/liveing.css"></style>
